var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"img_box",on:{"click":_vm.goApply}},[_c('img',{attrs:{"src":require("../../assets/img/finance_2/loan_1.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }